/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Blog_HeadingInputs */

const en_marketing_blog_heading = /** @type {(inputs: Marketing_Blog_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes from the build.`)
};

const es_marketing_blog_heading = /** @type {(inputs: Marketing_Blog_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas del proceso.`)
};

const fr_marketing_blog_heading = /** @type {(inputs: Marketing_Blog_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes de chantier.`)
};

/**
* | output |
* | --- |
* | "Notes from the build." |
*
* @param {Marketing_Blog_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_blog_heading = /** @type {((inputs?: Marketing_Blog_HeadingInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Blog_HeadingInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_blog_heading(inputs)
	if (locale === "es") return es_marketing_blog_heading(inputs)
	return fr_marketing_blog_heading(inputs)
});